import { useQuery } from "@tanstack/react-query";
import { styled } from "@monolith-forensics/monolith-ui";
import { AnalysisAPI } from "@/api";
import ActivityFeed from "@/components/ActivityFeed/ActivityFeed";

const StyledContainer = styled.div`
  margin-top: 15px;

  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: 0px;
`;

export const FlyoutActivityTab: React.FC<{
  defaultData: { uuid: string };
}> = ({ defaultData }) => {
  const { data, isLoading } = useQuery({
    queryKey: [
      "analysis",
      "logs",
      "list",
      { uuid: defaultData.uuid, object_type: "timeline_event" },
    ],
    queryFn: ({ queryKey }) => {
      const [, , , query] = queryKey;
      return AnalysisAPI.Logs.get(query);
    },
    enabled: !!defaultData.uuid,
  });

  const logs = (data?.data || []).reverse();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <StyledContainer>
      <ActivityFeed logs={logs} />
    </StyledContainer>
  );
};
